import qz from "qz-tray";
import { api } from "@/lib/api";

const PRINTER_KEY = "rj_dm_printer";
let configured = false;

function configure() {
  if (configured) return;
  qz.api.setPromiseType((resolver) => new Promise(resolver));
  qz.security.setCertificatePromise((resolve, reject) => {
    api.get("/print/qz/certificate", { responseType: "text", transformResponse: [(d) => d] }).then((r) => resolve(r.data)).catch(reject);
  });
  qz.security.setSignatureAlgorithm("SHA512");
  qz.security.setSignaturePromise((toSign) => (resolve, reject) => {
    api.post("/print/qz/sign", toSign, { headers: { "Content-Type": "text/plain" }, responseType: "text", transformResponse: [(d) => d] })
      .then((r) => resolve(String(r.data).trim())).catch(reject);
  });
  configured = true;
}

export async function qzConnect() {
  configure();
  if (!qz.websocket.isActive()) await qz.websocket.connect({ retries: 1, delay: 1 });
}

export const qzActive = () => configured && qz.websocket.isActive();

export async function qzPrinters() {
  await qzConnect();
  const list = await qz.printers.find();
  return Array.isArray(list) ? list : [list];
}

export async function qzPrintRaw(printer, base64, jobName) {
  await qzConnect();
  const cfg = qz.configs.create(printer, { jobName: jobName || "Rasa Juara Sales Hub" });
  return qz.print(cfg, [{ type: "raw", format: "command", flavor: "base64", data: base64 }]);
}

export const getPrinter = () => localStorage.getItem(PRINTER_KEY) || "";
export const getAutoPrintDo = () => localStorage.getItem("rj_dm_autoprint_do") !== "0";
export const setAutoPrintDo = (on) => localStorage.setItem("rj_dm_autoprint_do", on ? "1" : "0");
export const savePrinter = (name) => (name ? localStorage.setItem(PRINTER_KEY, name) : localStorage.removeItem(PRINTER_KEY));

// ESC/P test page for LX-310 (A5 landscape, 12 cpi, 35 lines)
export function testPageBase64() {
  const lines = ["RASA JUARA SALES HUB - TES PRINTER", "-".repeat(96), "Jika teks ini rapi dalam satu baris lebar 96 karakter,", "printer siap mencetak SO, DO, Invoice dan Kwitansi.", "", "1234567890".repeat(9) + "123456"];
  const esc = "\x1b@\x1bx\x00\x1bM\x1b2\x1bC" + String.fromCharCode(35) + "\x1bE" + lines[0] + "\x1bF\r\n" + lines.slice(1).join("\r\n") + "\r\n\x0c";
  return btoa(esc);
}

export function qzErrorText(e) {
  const msg = String(e?.message || e || "");
  if (/Unable to establish|websocket|connect/i.test(msg)) return "QZ Tray tidak terdeteksi. Pastikan aplikasi QZ Tray sudah terpasang & berjalan di komputer ini.";
  if (/rejected|denied|blocked/i.test(msg)) return "Permintaan cetak ditolak di QZ Tray. Klik Allow dan centang Remember this decision.";
  return msg || "Gagal mengirim ke printer";
}
